import React, { useEffect, useRef, useState } from "react";
import NavigationBar from "../../ReusableComp/NavigationBar";
import NavBarLeft from "../../ReusableComp/NavBarLeft";
import Select from "./../../ReusableComp/Select";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PopUpModal, { PopUpAlert } from "../../ReusableComp/PopUpModal";
import { toast } from 'react-toastify';
import EventMeetCase, { EventMeetCaseAPIData } from "./EventMeetCase";
import EventNotMeetCase, { EventNotMeetCaseAPIData } from "./EventNotMeetCase";
import axios from "../../../axios-interceptor";
import { Editor } from '@tinymce/tinymce-react';
import { EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_CLASSIFICATION_AESI, base_url, TINY_API_KEY } from "../../../utilities";
import { allAeBankEvents, createNewEvent, getAllEventClassification,  getEventbyId, updateEventbyId } from "../../../Redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Col } from 'react-bootstrap';
import { Tooltip } from "react-tooltip";
import Loader from "../../ReusableComp/Loader";
import { MeddraDetails } from "../../Quality_Reviewer/ReviewList";


const PMSAdverseEventBank = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("login_user_name")) {
      navigate("/");
    }
  }, []);
  const dispatch = useDispatch();

  // const handleEditorChange = (content, editor) => {
  //   setTextAreaChange(true)

  //   let value = content;
  //   let data = (aesiData.aesi_description = value)

  //   setOthersTextArea(data)

  // };

  const handleEditorChange = (content, editor) => {
    let value = content;
    let data = (aesiData.aesi_description = value);
  
    if (value.trim() === '') {
      setTextAreaChange(false);
    } else {
      setTextAreaChange(true);
    }
  
    setOthersTextArea(data);
  };  

  // const [adverseEvents, setAdverseEvents] = useState([])
  const eventDtls = useSelector((state) => state.eventDtls);
  
  const getClassifications = useSelector((state) => state.getAllClassifications);
  const myNodeRef = useRef(null);

  const allAdvEvents = useSelector((state) => (state.allAeEventsData));
  const medraList = useSelector((state) => (state.medraList));
  const [backGrdClr, setBackGrdClr] = useState('')
  const [singleEventData, setSingleEventData] = useState([])
  const [levelDataMeetCase, setLevelDataMeetCase] = useState([])
  const [levelDataNotMeetCase, setLevelDataNotMeetCase] = useState([])
  const [gradeData, setGradeData] = useState([])
  const [aesiData, setAESIData] = useState([])
  const [searchTerm, setSearchTerm] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [btnTitle, setBtnTitle] = useState("");
  const [eventName, setEventName] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const [eventLogVisible, setEventLogVisible] = useState();
  const [eventClass, setEventClass] = useState()
  const [openDeleteNew, setOpenDeleteNew] = React.useState(false);
  const [othersTextArea, setOthersTextArea] = useState()
  const [textAreas, setTextAreas] = useState([""]);
  const [textAreaMeetCase, setTextAreaMeetCase] = useState([""]);
  const [textAreaAddMeetCase, setTextAreaAddMeetCase] = useState([]);
  const [textAreasNotMeetCase, setTextAreasNotMeetCase] = useState([""]);
  const [textAreaAddNotMeetCase, setTextAreaAddNotMeetCase] = useState([]);
  const [updateTextAreas, setUpdateTextAreas] = useState([])
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [deleteNewTextArea, setDeleteNewTextArea] = useState(null);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [updateBtn, setUpdateBtn] = useState(false)
  const [meddra, setMeddra] = useState({});
  const [isBtn, setIsBtn] = useState(false)
  const [masterArray2, setMasterArray2] = useState([])
  const [reviewedDtls, setReviewedDtls] = useState(false);
  const [meddraClassification, setMeddraClassification] = useState();
  const [medView, setMedView] = useState(true)
  const [loading, setLoading] = useState(false);
  const [textAreaChange,setTextAreaChange]= useState(false)




  let blankTextAreas = updateTextAreas.some(i => i=='')
  let disableFortextAreas = textAreas.some(i => i=='')
  const [inputValue, setInputValue] = useState()
useEffect(() => {
  if(localStorage.access_token !== "undefined")
  {setLoading(true)}
  if(allAdvEvents){
    setLoading(false)
  }
  if (eventDtls) {
    setValue(eventDtls.meddraObject?.llt_name);
    setInputValue(eventDtls.meddraObject?.llt_name);
    // setIsMedraSelected(true)
    setMeddraClassification(eventDtls?.meddraObject)
  }

}, [eventDtls?.adverse_event_mapping_id, eventDtls, medraList,allAdvEvents])

  useEffect(() => {
    dispatch(getEventbyId())
    dispatch(updateEventbyId())
    dispatch(allAeBankEvents())
    dispatch(getAllEventClassification())
    

  }, [dispatch])



  const options = getClassifications && getClassifications.map((event) => ({
    value: event.event_classification_id,
    label: event
  }));
  const [flag, setFlag] = useState(false)

  const handleOptionSelect = (event, option, key) => {
    setEventClass(option === 'Brighton' ? EVENT_CLASSIFICATION_LEVEL_BRIGHTON : option === 'CTCAE' ? EVENT_CLASSIFICATION_GRADE_CTCAE : option === 'AESI' ? EVENT_CLASSIFICATION_AESI : option === 'Select Classification' ? '' : '')
    setSelectedKey(key);
    setTextAreas([""])
    setTextAreaMeetCase([""])
    setTextAreasNotMeetCase([""])
    setOthersTextArea('')
    setGetValue('');
  };
 

  function handleOption(e) {
    setSearchTerm(e.llt_name);
    setShowPopup(false)
    setBtnTitle(e.llt_name)
    setMeddra({
      label: e.llt_name,
      value: e.meddra_llt_master_id,
      meddra_mdhier_master_id:e.meddra_mdhier_master_id,
    })
  }


  const notMeetCaseDef = (props) => {
    setTextAreasNotMeetCase(props)
  }
  const meetCaseDef = (props) => {
    setTextAreaMeetCase(props)
  }
  const meetUpdateCaseDef = (props) => {
    setTextAreaAddMeetCase(props)
  }
  const notMeetUpdateCaseDef = (props) => {
    setTextAreaAddNotMeetCase(props)
  }

  const addTextArea = () => {
    setTimeout(() => {
      setTextAreas((prevTextAreas) => [...prevTextAreas, ""]);
    }, 300);
  };


  const modifiedKeyValues = updateTextAreas.filter((i) => i !== '').map((i) => ({
    ctcae_id: null,
    ctcae_definition: i
  }));

  const keyValuesOfMeetCase = textAreaAddMeetCase.filter((i) => i !== '').map((i) => ({
    event_meets_case_id: null,
    event_meets_case_definition: i
  }));
  const keyValuesOfNotMeetCase = textAreaAddNotMeetCase.filter((i) => i !== '').map((i) => ({
    event_doesnt_meets_case_id: null,
    event_doesnt_meets_case_definition: i
  }));

  const isButtonDisabled = updateTextAreas.some((i) => i === null || i === '');
  const isBtnDsbldMeetCase = textAreaAddMeetCase.some((i) => i === null || i === '');
  const isBtnDsbldNotMeetCase = textAreaAddNotMeetCase.some((i) => i === null || i === '');
 


  const otherObj = {
    aesi_description_id: aesiData.aesi_description_id,
    aesi_description: aesiData.aesi_description
  }

  const updateAddTextArea = () => { 
    setTimeout(() => {
      setUpdateTextAreas((prev) => [...prev, ""]);
      setTextAreaChange(true)
      
    }, 200);
  };
  const [getVlaue, setGetValue] = useState("")
  const allNotEmptyTextAreas = textAreas.every(text => text !== "");

  const handleTextAreaChange = (index, e, textAreaValue) => {  
      
    const value = e.target.value;
    setGetValue(value)
    const updatedTextAreas = [...textAreas];
    updatedTextAreas[index] = value;
    setTextAreas(updatedTextAreas)


  };
 
  const handleTextareaKeyDown = (e) => {
    if (e.key === ' ' && !getVlaue.trim() && !e.target.selectionStart) {
      e.preventDefault();
    }
  };

  const handleDeleteClick = (case_definition, event_id, meets_case) => {

   
    setRecordToDelete({
      case_definition: case_definition,
      event_id: event_id,
      meets_case: meets_case
    });
    setOpenDelete(true);
  };

  const deleteEventHandler = () => {
    if (recordToDelete) {
      axios
        .post(base_url + "aebank/delete_aebank_event_by_id",
          {
            "case_definition": recordToDelete.case_definition,
            "meets_case": recordToDelete.meets_case,
            "event_id": recordToDelete.event_id,
            "updated_by": localStorage.getItem("login_user_name")
          }
        )
        .then((res) => {
          let resData = (res.data.data)
         
          let data = gradeData.filter(i => i.ctcae_id !== resData.ctcae_id)
          setGradeData(data)
          let caseMeetData = levelDataMeetCase.filter(i => i.event_meets_case_id !== resData.event_meets_case_id)
          setLevelDataMeetCase(caseMeetData)
          let caseNotMetData = levelDataNotMeetCase.filter(i => i.event_doesnt_meets_case_id !== resData.event_doesnt_meets_case_id)
          setLevelDataNotMeetCase(caseNotMetData)
        })
        .catch((err) => {
          console.log(err);
        });
      setRecordToDelete(null);
      setOpenDelete(false)
    }


  }


  const handleNewTextAreaDelete = (textareas, index) => { 
    setDeleteNewTextArea({ textareas: textareas, index: index })
    setOpenDeleteNew(true);
  }

  const deleteNewTextBoxes = () => {
    deleteNewTextArea.textareas.splice(deleteNewTextArea.index, 1)
    setDeleteNewTextArea(deleteNewTextArea.textareas, null)
    setOpenDeleteNew(false);
  }

  // const handleUPdateTextChange = (e, key) => {
  //       setTextAreaChange(true)
  //   let matchedId = gradeData.filter(i => {
  //     if (i.ctcae_id === key) {
  //       return i.ctcae_definition = e.target.value
  //     }
  //     return i
  //   })
  //   setGradeData(matchedId)


  // }
  const handleUPdateTextChange = (e, key) => {
    //  setTextAreaChange(true)
    let matchedId = gradeData.filter(i => {
      if (i.ctcae_id === key) {
        return i.ctcae_definition = e.target.value
      }
      return i
    })
    if(matchedId.length===0){
      setTextAreaChange(false)
    }else{
      setTextAreaChange(true)
    }
    setGradeData(matchedId.length!==0 ? matchedId : ([...gradeData]))
  };

  const updatedDataforApi = (e, index) => {
    const value = e.target.value;
    const updatedValue = [...updateTextAreas];
    updatedValue[index] = value;
    setUpdateTextAreas(updatedValue);

  }
  const handleAdverseEvent = (e) => {    
    // const value = e.target.value.replace(/[^a-z ]/gi, '');
    const value = e.target.value.replace(/\d/g, '');
    
    if (value !== '') {
      setEventName(value);     

    } else if (value === '') {
      setEventName('');    

    }
  };

  const handleCreateEvent = () => {
    setSingleEventData([])
    setBackGrdClr('')
    setEventLogVisible(true);
    setUpdateBtn(false)
    setFlag(true)
  };

  let concatinatedArray = [...textAreaMeetCase, ...textAreasNotMeetCase]
  let allValuesNotEmpty = concatinatedArray.every((value) => value !== '');
  

  let createNewEventObj = {
    "aebank_event_title": eventName,
    "event_classification_id": selectedKey,
    "case_definition": eventClass,
    "event_definition": eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE ? textAreas : eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? [textAreaMeetCase, textAreasNotMeetCase] : [othersTextArea],
    "created_by": localStorage.login_user_name,
    "meddra_llt_master_id": masterArray2.meddra_llt_master_id ? masterArray2.meddra_llt_master_id : null,
    "meddra_mdhier_master_id":masterArray2.meddra_mdhier_master_id ?masterArray2.meddra_mdhier_master_id:null
  }

 let maasterLLT_id = createNewEventObj?.meddra_llt_master_id

  const [saveAlert, setSaveAlert] = useState(false)

    const viewProfile = () => {
  setOpenUpdate(false)
      window.location.reload()
      
    }

  const handleSaveEvent = () => {

    // dispatch(createNewEvent(createNewEventObj))
    // setSaveAlert(true)
    axios
      .post(base_url + "aebank/create_aebank_event", createNewEventObj)
      .then((res) => {
        if(res.data.data == "Validation error"){
          toast.error("This Event has already been created. ", {
            toastId: 1
          }   
          )
        }else if(res.data.message == "Brighton Events Saved" || res.data.message == "CTCAE Events Saved" || res.data.message == "AESI Events Saved")
              setSaveAlert(true)
         })
      .catch((err) => {
        console.log(err);
      });

  };


  const gradePlusAddedArray = [...modifiedKeyValues, ...gradeData]
  const levelPlusAddedMeetCases = [...keyValuesOfMeetCase, ...levelDataMeetCase]
  const levelPlusAddedNotMeetCases = [...keyValuesOfNotMeetCase, ...levelDataNotMeetCase]
  let obj = {
    "aebank_id": singleEventData.aebank_id,
    "case_definition": singleEventData.case_definition,
    "event_definition": singleEventData.case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? gradePlusAddedArray :
      singleEventData.case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? [levelPlusAddedMeetCases, levelPlusAddedNotMeetCases] :
        [otherObj],
    "created_by": localStorage.getItem('login_user_name'),
    "updated_by": localStorage.getItem('login_user_name'),
    "meddra_llt_master_id": masterArray2.meddra_llt_master_id ? masterArray2.meddra_llt_master_id : null,
    "meddra_mdhier_master_id":masterArray2.meddra_mdhier_master_id ?masterArray2.meddra_mdhier_master_id:null

  }
 
  const handleUpdateEvent = () => {
    dispatch(updateEventbyId(obj))
    setOpenUpdate(true);
  

  }



  const handleClose = () => {
    setSaveAlert(false)
    setOpenUpdate(false)
    setTimeout(() => {
      window.location.reload()
    }, 300);
  };

  const [searchData, setSearchData] = useState()
  const [value, setValue] = useState("");
  const handleSearchEvent = (e) => {
    setSearchData(e.target.value)

  };
const [meetsCaseDef, setMeetsCaseDef] = useState()
const [doesntmeetCaseDef, setDoesntmeetCaseDef] = useState()

  const handleSingleEvent = (data) => {
    setTextAreaChange(false)
    setValue("")
    meddraDetails.map(data => {
          data.meddraArray = []
          data.searchTerm = ''
          
        })
 setMeddraDetails(meddraDetails)
    setSingleEventData(data)
    if (updateTextAreas[0] == '') {
      setUpdateTextAreas([])
    }
    if (textAreaAddMeetCase[0] == '') {
      setTextAreaAddMeetCase([])
    }
    if (textAreaAddNotMeetCase[0] == '') {
      setTextAreaAddNotMeetCase([])
    }
    setEventClass()
    setUpdateBtn(true)
    setEventLogVisible(false);
    setFlag(true)

    setBackGrdClr(data.aebank_id)
    switch (data.case_definition) {
      case EVENT_CLASSIFICATION_LEVEL_BRIGHTON:
        data.case_definition_name = "Level";
        break
      case EVENT_CLASSIFICATION_GRADE_CTCAE:
        data.case_definition_name = "Grade";
        break
      case EVENT_CLASSIFICATION_AESI:
        data.case_definition_name = "AESI";
        break
    }


    axios
      .post(base_url + "aebank/get_ae_bank_event_by_id", {
        "aebank_id": data.aebank_id,
        "aebank_event_title": data.aebank_event_title,
        "case_definition": data.case_definition,
        "event_classification_id": data.event_classification_id
      })
      .then((res) => {
        let resdata = (res.data.data)
        switch (data.case_definition) {
          case EVENT_CLASSIFICATION_LEVEL_BRIGHTON:
            setMeetsCaseDef(resdata[0].event_doesnt_meets_case_definition)
            setDoesntmeetCaseDef(resdata[0].event_doesnt_meets_case_definition)
            setLevelDataMeetCase(resdata[0].event_meets_case)
            setLevelDataNotMeetCase(resdata[1].event_doesnt_meets_case)
            break
          case EVENT_CLASSIFICATION_GRADE_CTCAE:
            setGradeData(resdata[0].grade_case)

            break
          case EVENT_CLASSIFICATION_AESI:
            setAESIData(resdata[0].other_case)

            break
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

 
  const[noRecordsFlag, setNoRecordsFlag] = useState(false)
  const [dotsFlag, setDotsFlag] = useState(false)
  const [loadFlag, setLoadFlag] = useState(false)
  const [listFlag, setListFlag] = useState(false)
  const [meddraDetails, setMeddraDetails] = useState([
    {
      "searchTerm": "",
      "current_idx": 0,
      "checkedMeddra":"",
      "medDRAEncode": false,
      "meddraArray": [],
    },
  ]);
  const [encodeMeddrabtn, setEncodeMeddrabtn] = useState(true);
  

  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  let debounceTimer;


  const handleMeddraClassification1 = (event, index) => {
    setListFlag(true)
    setDotsFlag(true)
    const inputValue = event.target.value;
    setQuery(inputValue);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 0) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
        
      }
    }, 300); 
    meddraDetails.map(data => {
      if (data.current_idx == index) {
        if (event.target.value == "") {

          data.meddraArray = []
          setValue("")
          data.searchTerm = ''
          setNoRecordsFlag(false)
          setDotsFlag(false)
          setListFlag(false)
          setEncodeMeddrabtn(true)
          data.medDRAEncode =false
          setMeddraDetails(meddraDetails)
          
        } else {
          setValue(event.target.value);
          data.searchTerm = event.target.value
          setEncodeMeddrabtn(true)
          setMeddraDetails(meddraDetails)
        }
      }
    })
  };
  
  const fetchSuggestions = async (searchQuery) => {
    axios
    .post(base_url + "meddra-master/fetch_all_llt_names_based_on_search_term",{"llt_name":searchQuery})
    .then((response) => {
    setSuggestions(response.data.data)
    setDotsFlag(false)
    if(response.data.data.length===0){
      setNoRecordsFlag(true)
    }
    })
  }

  const onEncode2 = (searchTerm, object) => {
    setLoadFlag(true)
    setMedView(false)
    setValue(searchTerm);
    axios
      .post(
        base_url + "meddra-master/fetch_llt_occurences", {
        "llt_name": searchTerm
      }
      )
      .then((res) => {
        let meddraArray = res.data.data
        setLoadFlag(false)
        meddraDetails.map((data, index) => {
      if (data.searchTerm != "" || null) {
        setIsBtn(true)
      }
      else {
        setIsBtn(false)
      }
      if (data.current_idx == object.current_idx) {
        meddraDetails[index].meddraArray = meddraArray;
        setMeddraDetails(meddraDetails)
        if (meddraArray?.length === 1) {
 
          setMasterArray2( {
            meddra_llt_master_id: meddraArray[0]?.meddra_llt_master_id,
            index: object.current_idx,
            meddra_mdhier_master_id: meddraArray[0]?.meddra_mdhier_master_id,

          })

        } else {

          setMasterArray2((prev) => ([...prev, {
            meddra_llt_master_id: null,
            index: object.current_idx,
            meddra_mdhier_master_id: null

          }]))
        }
      }
    })
  })
  }

  const onSearch = (sTerm, index) => {
    setListFlag(false)
    setValue(sTerm);
    meddraDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = sTerm
        data.medDRAEncode = true
        setMeddraDetails(meddraDetails)
        setEncodeMeddrabtn(false)

      }
    })
  };  
  const handleCheckboxChange2 = (selectedCheckbox, index) => {
  
    let updatedData = [...meddraDetails]
    updatedData.map(i => {
      if(i.current_idx === index){
        i.checkedMeddra = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    setMasterArray2({
        meddra_llt_master_id : selectedCheckbox.meddra_llt_master_id,
        meddra_mdhier_master_id : selectedCheckbox.meddra_mdhier_master_id
      })
    
    setMeddraDetails(updatedData)
    // setIsBtn(true)
  }; 

  const getTextAreaChange = (msg) => { 
    setTextAreaChange(msg) 
  }
  useEffect(() =>{
    if (masterArray2.length === 0){
      setTextAreaChange(false)
    }
    else{
      setTextAreaChange(true) 
    }
  },[masterArray2]
  ) 
  

 
  return (
    <div>
      <NavigationBar studyDropdwn={true} title={"Adverse Event Master"} />
      <div className="main_body adverse_event_main">
        <div className="row  "  >
          <div className="col-lg-3  pmsaebankbodystyl" style={{ backgroundColor: "#E2E8F0" }}>
            <div className="left_content">
              <div className="search_container ">
                <img
                  src="./images/icons/search_magnifier.svg"
                  alt=""
                  className="search_icon"
                />
                <input
                  className="search_field"
                  placeholder="Adverse Events"
                  type="text"
                  onChange={(e) => handleSearchEvent(e)}
                />
              </div>
              <button className="AE_gray_btn" onClick={handleCreateEvent}>
                Create New Adverse Event
              </button>
              <div
                className={`${allAdvEvents?.length > 8
                  ? "adv_event p-0 pb-1 pe-2"
                  : "adv_event p-0 pb-1"
                  } `}
              >
                {allAdvEvents && allAdvEvents?.filter((e) => {
                  const eventTitle = e.aebank_event_title || '';

                  return eventTitle.toLowerCase().startsWith((searchData || '').toLowerCase())
                }).map((event, index) => {
                  return (
                    <div onClick={() => handleSingleEvent(event)} key={event.aebank_id} className={`${backGrdClr === event.aebank_id ? 'single_ae' : 'adverse_event'} centered-event`} >
                      <p >{event.aebank_event_title}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className={`col txt-container ${flag ? 'd-none' : ''}`} >
            <h5 className="aebanktxt">Please click on "Create New Adverse Event" button to create a new event.</h5>
          </div>
          {eventLogVisible && (
            <div className="col right_content d-flex flex-column pmsaebankbodystyl" >
              <div className="col d-flex gap-3 flex-column " style={{ padding: "3rem 8rem 3rem 4rem" }} >
                <div className="AE_input ">
                  <label className="AE_labels" htmlFor="eventName">
                    Event Name<span className="text-danger">*</span>
                  </label>
                  <input
                    autoFocus
                    className=""
                    // onKeyDown={handleKeyDown}
                    value={eventName}
                    id="eventName"
                    type="text"
                    placeholder="Enter event name"
                    onChange={handleAdverseEvent}
                  />
                </div>
                <div className="custom_select_main">
                <Select
                  selectdivstyl={"AE_input"}
                  required={"*"}
                  name={"classification"}
                  width={"364px"}
                  label={"Event Classification"}
                  options={options}
                  initialValue={"Select Classification"}
                  onChange={handleOptionSelect}
                  className="main_mh adverse"  
               />
               </div> 
                <div className="AE_input mb-3">
                  <label className="AE_labels" htmlFor="eventName">
                    Case Definition
                  </label>
                  <input
                    className=""
                    id="eventName"
                    type="text"
                    placeholder={""}
                    value={
                      eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON
                        ? "Level"
                        : eventClass === EVENT_CLASSIFICATION_AESI
                          ? "AESI"
                          : eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE
                            ? "Grade"
                            : ""
                    }
                    disabled
                    onChange={handleAdverseEvent}
                  />
                </div>

             
                {eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE && (
                  <div className="textarea_btn_div">
                    <TransitionGroup>
                      {textAreas.map((textAreaValue, index) => {

                        return (
                          <CSSTransition nodeRef={myNodeRef} key={index} timeout={1000} classNames="fade">
                            <div className="textarea_item ">
                              {index !== 0 && <button
                                onClick={() => handleNewTextAreaDelete(textAreas, index)}
                                className="minus_btn"
                              >
                                <span>x</span>
                              </button>}
                              <textarea
                                value={textAreaValue}
                                onKeyDown={handleTextareaKeyDown}
                                onChange={(event) => handleTextAreaChange(index, event, textAreaValue)}
                                placeholder="Type event definition"
                              />
                            </div>
                          </CSSTransition>
                        )
                      })}
                    </TransitionGroup>
                    <button disabled={disableFortextAreas} onClick={addTextArea} className="plus_btn">
                      <span>+</span>
                    </button>
                  </div>
                )}
                {/* =====================Event meets case definition after API resp=================== */}
                {eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON && (
                  <div className="ct_event_main">
                    <EventMeetCase meetCaseDef={meetCaseDef} textAreaMeetCase={textAreaMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete} />
                    {/* =============== Event does not meet case definition after API resp================== */}
                    <EventNotMeetCase notMeetCaseDef={notMeetCaseDef} textAreasNotMeetCase={textAreasNotMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete} />
                  </div>
                )}
                {/* ================other============== */}
                {eventClass === EVENT_CLASSIFICATION_AESI && (
                  <div className="textarea_btn_div mb-3">
                    <Editor apiKey={TINY_API_KEY}
                      cloudChannel="5-stable"
                      disabled={false}
                      inline={false}
                      onEditorChange={handleEditorChange}
                      plugins=""
                      tagName="div"
                      textareaName="body"
                      toolbar="undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat forecolor backcolor"
                      value={othersTextArea}
                      outputFormat="html"
                      init={{
                        height: 250,
                        language: "en",
                        //menubar: false,
                        plugins: [
                          "advlist autolink lists link image charmap print preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste code help wordcount",
                        ],
                        convert_urls: false,
                        placeholder: "Type event definition"
                      }}
                      // Add aria-required attribute
                      aria-required={true}
                      name="others"
                      className="ae_other_option_textarea_editior" // Add the className attribute
                    />
                  </div>
                )}
                <div className="">
         

{/* =============================Create event========================================= */}
                      <MeddraDetails
                    noRecordsFlag={noRecordsFlag}
                    dotsFlag={dotsFlag}
                    loadFlag={loadFlag}
                    listFlag={listFlag}
                      meddraDetails={meddraDetails}
                      handleMeddraClassification1={handleMeddraClassification1}
                      encodeMeddrabtn={encodeMeddrabtn}
                      value={value}
                      inputValue={inputValue}
                      handleCheckboxChange2={handleCheckboxChange2}
                      reviewedDtls={reviewedDtls}
                      medView={medView}
                      meddraClassification={meddraClassification}
                      onEncode2={onEncode2}
                      suggestions={suggestions}
                      onSearch={onSearch} />
{/* ====================================================================== */}


          </div>
              </div>
            
            </div>
          )}
          {/* ===========================Get Event Code============================================= */}
          {singleEventData.length !== 0 ? <div className="col right_content d-flex flex-column pmsaebankbodystyl">
            <div className="col d-flex gap-3 flex-column" style={{padding: "2rem 5rem 3rem 4rem" }}>
              <div className="AE_input ">
                <label className="AE_labels" htmlFor="eventName">
                  Event Name
                </label>
                <input
                  className=""
                  disabled
                  id="eventName"
                  type="text"
                  placeholder={singleEventData.aebank_event_title}
                  style={{ width: "365px" }}
                />
              </div>
              <div className="AE_input ">
                <label className="AE_labels" htmlFor="eventName">
                  Event Classification
                </label>
                <select value={singleEventData.case_definition} className="custom-select" style={{ width: "365px", height: "50px" }}>
                  <option value="">{singleEventData.event_classification_label}</option>
                </select>
              </div>
              <div className="AE_input ">
                <label className="AE_labels" htmlFor="eventName">
                  Case Definition
                </label>
                <input
                  className=""
                  id="eventName"
                  type="text"
                  placeholder={""}
                  value={singleEventData.case_definition_name}
                  disabled
                  onChange={handleAdverseEvent}
                />
              </div>

              {singleEventData?.llt_name == null ? '' : <div className="AE_input ">
                <label className="AE_labels" htmlFor="eventName">
                  Meddra Classification
                </label>
                <input
                  className=""
                  id="eventName"
                  type="text"
                  placeholder={""}
                  value={singleEventData?.llt_name == null ? "" : singleEventData?.llt_name}

 
                  disabled
                  onChange={handleAdverseEvent}
                />
              </div>
              }



              {singleEventData.case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE && (
                <div className="textarea_btn_div">
                  {gradeData?.map((textAreaValue, index) => {
                    return (
                      <div className="textarea_item " key={textAreaValue.ctcae_id}>
                        {index !== 0 && <button
                          onClick={() => handleDeleteClick(EVENT_CLASSIFICATION_GRADE_CTCAE, textAreaValue.ctcae_id, null)}
                          className="minus_btn"
                        >
                          <span>x</span>
                        </button>}
                        <textarea
                          value={textAreaValue.ctcae_definition}
                          onChange={(event) => handleUPdateTextChange(event, textAreaValue.ctcae_id)}
                          placeholder="Type event definition"
                        />
                      </div>
                    )
                  })}

                  
                  {updateTextAreas?.map((txtArea, index) => {
                    return (
                      <div className="textarea_item " key={index}>
                        <button
                          onClick={() => handleNewTextAreaDelete(updateTextAreas, index)}
                          className="minus_btn"
                        >
                          <span>x</span>
                        </button>
                        <textarea
                          value={txtArea}
                          name='addtextarea'
                          onChange={(event) => updatedDataforApi(event, index)}
                          placeholder="Type event definition"
                        />
                      </div>
                    )
                  })}
                  <button disabled={blankTextAreas || gradeData[0]?.ctcae_definition==""} onClick={updateAddTextArea} className="plus_btn">
                    <span>+</span>
                  </button>
                </div>
              )}
              {singleEventData.case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON && (
                <div className="ct_event_main">
                  <EventMeetCaseAPIData handleDeleteClick={handleDeleteClick} meetUpdateCaseDef={meetUpdateCaseDef} textAreaAddMeetCase={textAreaAddMeetCase} leveldata={levelDataMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete} getTextAreaChange={getTextAreaChange} />
                  <EventNotMeetCaseAPIData handleDeleteClick={handleDeleteClick} notMeetUpdateCaseDef={notMeetUpdateCaseDef} textAreaAddNotMeetCase={textAreaAddNotMeetCase} leveldata={levelDataNotMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete}  getTextAreaChange={getTextAreaChange}/>
                </div>
              )}
              {singleEventData.case_definition === EVENT_CLASSIFICATION_AESI && (
                <div className="textarea_btn_div">

                  <Editor apiKey={TINY_API_KEY}
                    cloudChannel="5-stable"
                    disabled={false}
                    inline={false}
                    onEditorChange={handleEditorChange}
                    plugins=""
                    tagName="div"
                    textareaName="body"
                    toolbar="undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat forecolor backcolor"
                    value={aesiData.aesi_description}
                    outputFormat="html"
                    init={{
                      height: 250,
                      language: "en",
                      //menubar: false,
                      plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help wordcount",
                      ],
                      convert_urls: false,
                      placeholder: "Type event definition"
                    }}
                    // Add aria-required attribute
                    aria-required={true}
                    name="others"
                    className="ae_other_option_textarea_editior" // Add the className attribute
                  />
                </div>
              )}


{/* =======================Get and update=================================== */}
                      <MeddraDetails
                    noRecordsFlag={noRecordsFlag}
                    dotsFlag={dotsFlag}
                    loadFlag={loadFlag}
                    listFlag={listFlag}
                      meddraDetails={meddraDetails}
                      handleMeddraClassification1={handleMeddraClassification1}
                      encodeMeddrabtn={encodeMeddrabtn}
                      value={value}
                      inputValue={inputValue}
                      handleCheckboxChange2={handleCheckboxChange2}
                      reviewedDtls={reviewedDtls}
                      medView={medView}
                      meddraClassification={singleEventData}
                      onEncode2={onEncode2}
                      suggestions={suggestions}
                      onSearch={onSearch} />
{/* ========================================================================= */}


            </div>
            
          </div> : ''}

          
        </div>
        <div className="AE_footer_save_btn  ">
          {eventLogVisible && (
            <div className="save_btn ">
              {eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE && <button className="orange_btn" onClick={handleSaveEvent}
                disabled={eventName !== '' && allNotEmptyTextAreas ? false : true}>
                Save
              </button>}
              {eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON && <button className="orange_btn" onClick={handleSaveEvent}
                disabled={eventName !== '' && allValuesNotEmpty ? false : true}>
                Save
              </button>}
              {eventClass === EVENT_CLASSIFICATION_AESI &&
                <button className="orange_btn" onClick={handleSaveEvent}
                  disabled={eventName !== '' && othersTextArea !== '' ? false : true}>
                  Save
                </button>}
            </div>
          )}

          {updateBtn && <div className="save_btn ">
            <button className="orange_btn" onClick={handleUpdateEvent}
              disabled={meddraDetails.length === 0 || isButtonDisabled || isBtnDsbldMeetCase || isBtnDsbldNotMeetCase || !textAreaChange}
            >
              Update
            </button>
          </div>}



          <PopUpModal handleClose={handleClose} open={saveAlert} title={"Success!"} msg={"New adverse event has been created!"} close={'Done'} actionbtn={'Done'} onConfirm={viewProfile} />
          <PopUpModal handleClose={handleClose} open={openUpdate} title={"Success!"} msg={"Adverse event updated successfully!"} close={'Done'} actionbtn={'Done'} onConfirm={viewProfile} />
          <PopUpAlert handleClose={() => setOpenDelete(false)} open={openDelete} title={"Confirm Delete!"} msg={"Are you sure you want to delete this event!"} close={'Cancel'} actionbtn={'Delete'} onConfirm={deleteEventHandler} />
          <PopUpAlert handleClose={() => setOpenDeleteNew(false)} open={openDeleteNew} title={"Confirm Delete!"} msg={"Are you sure you want to delete this event!"} close={'Cancel'} actionbtn={'Delete'} onConfirm={deleteNewTextBoxes} />
        </div>

      </div>
      {loading && <Loader />}

    </div>
  );
};

export default PMSAdverseEventBank;

